import React from "react";
import { Tabs, Tab, Typography } from "@mui/material";

interface StatusTabsProps {
  tabValue: number;
  handleTabChange: (event: React.SyntheticEvent, newValue: number) => void;
  tabLabels: string[];
  tabCounts: Record<string, number>;
}

const StatusTabs: React.FC<StatusTabsProps> = ({
  tabValue,
  handleTabChange,
  tabLabels,
  tabCounts,
}) => {
  return (
    <Tabs
      value={tabValue}
      onChange={handleTabChange}
      aria-label="content tabs"
      sx={{
        "& .MuiTab-root": { textTransform: "none" },
        "& .Mui-selected": { color: "primary.main", fontWeight: "bold" },
      }}
    >
      {tabLabels.map((label, idx) => {
        const countKey = label.split(" ")[0]; // Extract the key for counts (e.g., "Pending Queue" -> "Pending")
        const count = tabCounts[countKey] || 0;
        return <Tab key={idx} label={`${label} (${count})`} />;
      })}
    </Tabs>
  );
};

export default StatusTabs;